import { ChromeFullscreen } from '/component/chrome/fullscreen';
import { ChromeMain } from '/component/chrome/main';
import { PageErrorComponent } from '/component/container/page/error';
import { useIsAuthenticated } from '/global-state/session/hooks';

export function NotFoundRoute() {
  const isAuthenticated = useIsAuthenticated();

  const ChromeComponent = isAuthenticated ? ChromeMain : ChromeFullscreen;

  return (
    <ChromeComponent>
      <PageErrorComponent type="notFound" />
    </ChromeComponent>
  );
}
